import styled from 'styled-components';

export const ErrorList = styled.div`
  color: ${({ theme }) => theme.red[400]};
  margin-top: 0.2rem;
  font-weight: 400;
  line-height: 1.66;
`;
